import React from "react";
import { Link } from "gatsby";
import { Layout, Menu } from "antd";
import { BookOutlined } from "@ant-design/icons";
const { Sider } = Layout;

export default class TutorialSider extends React.Component {
  render() {
    return (
      <Sider
        breakpoint="lg"
        collapsedWidth="0"
        onBreakpoint={(broken) => {
          console.log(broken);
        }}
        onCollapse={(collapsed, type) => {
          console.log(collapsed, type);
        }}
      >
        <Link to={`/guide-content/tutorial/`}>
          <h2 style={{ textAlign: "center", marginTop: 20 }}>
            <BookOutlined />
            Tutorial
          </h2>
        </Link>
        <div>
          <Menu theme="light">
            <Menu.Item key="0">
              <Link to="/guide">Back To Guide</Link>
            </Menu.Item>
            <Menu.Item key="1">
              <Link to="/tutorial-content/quick-start/">Quick Start</Link>
            </Menu.Item>
            <Menu.Item key="2">
              <Link to="/tutorial-content/tutorial-2/">Notes &amp; Labels</Link>
            </Menu.Item>
            <Menu.Item key="3">
              <Link to="/tutorial-content/tutorial-3/">Payment Tracking</Link>
            </Menu.Item>
            <Menu.Item key="4">
              <Link to="/tutorial-content/tutorial-4/">Recur Entries</Link>
            </Menu.Item>
            <Menu.Item key="5">
              <Link to="/tutorial-content/team-room/">Team Room</Link>
            </Menu.Item>
            <Menu.Item key="6">
              <Link to="/tutorial-content/scheduler/">Work Scheduling</Link>
            </Menu.Item>
          </Menu>
        </div>
      </Sider>
    );
  }
}
